var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isSVG && _vm.lazy)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:({
    src: _vm.regularImage,
    loading: require('~/assets/images/loading.png'),
  }),expression:"{\n    src: regularImage,\n    loading: require('~/assets/images/loading.png'),\n  }"}],class:[_vm.classes, { 'loading-blur': !_vm.isSVG && _vm.lazy }],attrs:{"src":require('~/assets/images/loading.png'),"alt":_vm.imageAlt}}):_c('img',{class:_vm.classes,attrs:{"src":_vm.regularImage,"alt":_vm.imageAlt}})
}
var staticRenderFns = []

export { render, staticRenderFns }